import { useState, useEffect } from 'react'
import { Typography } from "@mui/material"

interface TimezoneClockProps {
  timezone: string
}

export function TimezoneClock({ timezone }: TimezoneClockProps) {
  const [currentTime, setCurrentTime] = useState<string>('')
  const [isValid, setIsValid] = useState<boolean>(true)

  useEffect(() => {
    const updateTime = () => {
      try {
        const now = new Date()
        const timeString = now.toLocaleTimeString('en-US', {
          timeZone: timezone,
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })
        setCurrentTime(timeString)
        setIsValid(true)
      } catch (error) {
        console.warn(`Invalid timezone: ${timezone}`, error)
        setIsValid(false)
        setCurrentTime('')
      }
    }

    // Update immediately
    updateTime()

    // Set up interval to update every minute
    const interval = setInterval(updateTime, 60000)

    // Cleanup interval on unmount
    return () => clearInterval(interval)
  }, [timezone])

  if (!isValid || !currentTime) {
    return null
  }

  return (
    <Typography component="span" sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
      {currentTime}
    </Typography>
  )
}
